
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/states/[state]",
      function () {
        return require("private-next-pages/sitemap/states/[state]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/states/[state]"])
      });
    }
  